export function timeformat(timer, format) {
    const { days, hours, minutes, seconds } = timer;
    if (!format)
        return '';
    let formated = format !== null && format !== void 0 ? format : '';
    const matchRules = {
        days: { rule: 'D{1,2}', value: days },
        hours: { rule: 'H{1,2}', value: hours },
        minutes: { rule: 'm{1,2}', value: minutes },
        seconds: { rule: 's{1,2}', value: seconds },
    };
    Object.entries(matchRules).forEach(([key, val]) => {
        const { rule, value } = val;
        const reg = new RegExp(`(${rule})`).exec(formated);
        // 模板替换，当输出模板中没有天，时，分的时候要将值向低一级的单位累加
        if (reg) {
            formated = formated.replace(reg[1], reg[1].length === 1
                ? String(value)
                : String(value).padStart(reg[1].length, '0'));
        }
        else if (key === 'days') {
            matchRules.hours.value = value * 24 + matchRules.hours.value;
        }
        else if (key === 'hours') {
            matchRules.minutes.value =
                value * 60 + matchRules.minutes.value;
        }
        else if (key === 'minutes') {
            matchRules.seconds.value =
                value * 60 + matchRules.seconds.value;
        }
    });
    return formated;
}
